export default {
  isSmall: () => window.matchMedia('(max-width: 38em)').matches,
  isLarge: () => window.matchMedia('(min-width: 60em)').matches,
};
